// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Recipient Selection Styling */
.recipient-label {
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.recipient-actions {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.recipient-action-btn {
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.recipient-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.selected-recipients-container {
  margin-bottom: 20px;
  border-radius: 4px;
}

.selected-recipients-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.selected-recipients-header {
  background-color: #f8f9fa;
  padding: 10px 15px;
  border-bottom: 1px solid #dee2e6;
}

.selected-count {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.selected-recipients-body {
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 150px;
  overflow-y: auto;
  background-color: #fff;
}

.recipient-badge {
  display: flex;
  align-items: center;
  background-color: #fff8e1;
  border: 1px solid #F79222;
  border-radius: 30px;
  padding: 5px 10px 5px 15px;
  font-size: 13px;
  transition: all 0.2s ease;
}

.recipient-badge:hover {
  background-color: #fff3cd;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.recipient-name {
  font-weight: 600;
  color: #F79222;
  margin-right: 5px;
}

.recipient-phone {
  color: #6c757d;
  font-size: 12px;
  margin-right: 10px;
}

.recipient-remove {
  background: none;
  border: none;
  color: #F9394C;
  cursor: pointer;
  padding: 0 5px;
  font-size: 14px;
  opacity: 0.7;
  transition: all 0.2s ease;
}

.recipient-remove:hover {
  opacity: 1;
  transform: scale(1.1);
}

.no-recipients-alert {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: #f8f9fa;
  border: 1px dashed #ced4da;
  border-radius: 4px;
  color: #6c757d;
  font-size: 14px;
}

.recipient-selector {
  position: relative;
}

.search-select-container {
  position: relative;
}

.search-input {
  height: 45px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 10px 15px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.search-input:focus {
  border-color: #F79222;
  box-shadow: 0 0 0 0.2rem rgba(247, 146, 34, 0.25);
}

.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  z-index: 1000;
}

.search-result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.search-result-item:last-child {
  border-bottom: none;
}

.search-result-item:hover {
  background-color: #fff8e1;
}

.member-info {
  display: flex;
  flex-direction: column;
}

.member-name {
  font-weight: 500;
  color: #333;
}

.member-phone {
  font-size: 12px;
  color: #6c757d;
}

.no-results {
  padding: 15px;
  text-align: center;
  color: #6c757d;
  font-style: italic;
}

/* Message Textarea Styling */
.message-label {
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.message-textarea {
  resize: vertical;
  min-height: 120px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 15px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.message-textarea:focus {
  border-color: #F79222;
  box-shadow: 0 0 0 0.2rem rgba(247, 146, 34, 0.25);
}

.message-counter {
  display: block;
  text-align: right;
  margin-top: 5px;
  font-size: 12px;
}

/* Button Styling to match loan application theme */
.btn {
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.2s ease;
}

/* Cancel Button */
.btn-cancel {
  background-color: #f8f9fa;
  border-color: #ddd;
  color: #333;
  transition: all 0.2s ease;
}

.btn-cancel:hover {
  background-color: #e9ecef;
  border-color: #ddd;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

/* Save Draft Button - Updated to outline style */
.btn-draft {
  background-color: transparent;
  border: 1px solid #F79222;
  color: #F79222;
  transition: all 0.2s ease;
}

.btn-draft:hover:not(:disabled) {
  background-color: rgba(247, 146, 34, 0.1);
  border-color: #F79222;
  color: #F79222;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.btn-draft:focus {
  box-shadow: 0 0 0 0.2rem rgba(247, 146, 34, 0.25);
}

/* Send Message Button */
.btn-send {
  background-color: #F79222;
  border-color: #F79222;
  color: white;
  transition: all 0.2s ease;
  font-weight: 600;
}

.btn-send:hover:not(:disabled) {
  background-color: #e07b10;
  border-color: #e07b10;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.btn-send:disabled, .btn-draft:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* Section styling to match loan application */
.section-header {
  margin-bottom: 20px;
}

.section-header h4 {
  color: #F9394C;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.section-header hr {
  margin-top: 0;
  border-color: #e9ecef;
}

.card-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #f8f9fa;
  border-bottom: 2px solid #F9394C;
}

.title-section {
  display: flex;
  align-items: center;
}

.title-icon {
  color: #333;
  font-size: 1.2rem;
  margin-right: 10px;
}

.card-title span {
  font-weight: 600;
  color: #333;
  font-size: 1.1rem;
}

.card-menus {
  display: flex;
  gap: 10px;
}

/* Compose Message Button */
.btn-compose {
  background-color: #F79222;
  border-color: #F79222;
  color: white;
  transition: all 0.2s ease;
  font-weight: 600;
}

.btn-compose:hover {
  background-color: #e07b10;
  border-color: #e07b10;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
} `, "",{"version":3,"sources":["webpack://./src/App/components/Messages/styles.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,wEAAwE;AAC1E;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wEAAwE;AAC1E;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,iDAAiD;AACjD;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,iDAAiD;AACnD;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,qCAAqC;AACvC","sourcesContent":["/* Recipient Selection Styling */\n.recipient-label {\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.recipient-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.recipient-action-btn {\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.recipient-action-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n\n.selected-recipients-container {\n  margin-bottom: 20px;\n  border-radius: 4px;\n}\n\n.selected-recipients-card {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.selected-recipients-header {\n  background-color: #f8f9fa;\n  padding: 10px 15px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.selected-count {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.selected-recipients-body {\n  padding: 15px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  max-height: 150px;\n  overflow-y: auto;\n  background-color: #fff;\n}\n\n.recipient-badge {\n  display: flex;\n  align-items: center;\n  background-color: #fff8e1;\n  border: 1px solid #F79222;\n  border-radius: 30px;\n  padding: 5px 10px 5px 15px;\n  font-size: 13px;\n  transition: all 0.2s ease;\n}\n\n.recipient-badge:hover {\n  background-color: #fff3cd;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.recipient-name {\n  font-weight: 600;\n  color: #F79222;\n  margin-right: 5px;\n}\n\n.recipient-phone {\n  color: #6c757d;\n  font-size: 12px;\n  margin-right: 10px;\n}\n\n.recipient-remove {\n  background: none;\n  border: none;\n  color: #F9394C;\n  cursor: pointer;\n  padding: 0 5px;\n  font-size: 14px;\n  opacity: 0.7;\n  transition: all 0.2s ease;\n}\n\n.recipient-remove:hover {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.no-recipients-alert {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border: 1px dashed #ced4da;\n  border-radius: 4px;\n  color: #6c757d;\n  font-size: 14px;\n}\n\n.recipient-selector {\n  position: relative;\n}\n\n.search-select-container {\n  position: relative;\n}\n\n.search-input {\n  height: 45px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  padding: 10px 15px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.search-input:focus {\n  border-color: #F79222;\n  box-shadow: 0 0 0 0.2rem rgba(247, 146, 34, 0.25);\n}\n\n.search-results {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  max-height: 250px;\n  overflow-y: auto;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  z-index: 1000;\n}\n\n.search-result-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.search-result-item:last-child {\n  border-bottom: none;\n}\n\n.search-result-item:hover {\n  background-color: #fff8e1;\n}\n\n.member-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.member-name {\n  font-weight: 500;\n  color: #333;\n}\n\n.member-phone {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.no-results {\n  padding: 15px;\n  text-align: center;\n  color: #6c757d;\n  font-style: italic;\n}\n\n/* Message Textarea Styling */\n.message-label {\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.message-textarea {\n  resize: vertical;\n  min-height: 120px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  padding: 15px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.message-textarea:focus {\n  border-color: #F79222;\n  box-shadow: 0 0 0 0.2rem rgba(247, 146, 34, 0.25);\n}\n\n.message-counter {\n  display: block;\n  text-align: right;\n  margin-top: 5px;\n  font-size: 12px;\n}\n\n/* Button Styling to match loan application theme */\n.btn {\n  font-weight: 500;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n/* Cancel Button */\n.btn-cancel {\n  background-color: #f8f9fa;\n  border-color: #ddd;\n  color: #333;\n  transition: all 0.2s ease;\n}\n\n.btn-cancel:hover {\n  background-color: #e9ecef;\n  border-color: #ddd;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n/* Save Draft Button - Updated to outline style */\n.btn-draft {\n  background-color: transparent;\n  border: 1px solid #F79222;\n  color: #F79222;\n  transition: all 0.2s ease;\n}\n\n.btn-draft:hover:not(:disabled) {\n  background-color: rgba(247, 146, 34, 0.1);\n  border-color: #F79222;\n  color: #F79222;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n\n.btn-draft:focus {\n  box-shadow: 0 0 0 0.2rem rgba(247, 146, 34, 0.25);\n}\n\n/* Send Message Button */\n.btn-send {\n  background-color: #F79222;\n  border-color: #F79222;\n  color: white;\n  transition: all 0.2s ease;\n  font-weight: 600;\n}\n\n.btn-send:hover:not(:disabled) {\n  background-color: #e07b10;\n  border-color: #e07b10;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n\n.btn-send:disabled, .btn-draft:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n/* Section styling to match loan application */\n.section-header {\n  margin-bottom: 20px;\n}\n\n.section-header h4 {\n  color: #F9394C;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.section-header hr {\n  margin-top: 0;\n  border-color: #e9ecef;\n}\n\n.card-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #F9394C;\n}\n\n.title-section {\n  display: flex;\n  align-items: center;\n}\n\n.title-icon {\n  color: #333;\n  font-size: 1.2rem;\n  margin-right: 10px;\n}\n\n.card-title span {\n  font-weight: 600;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.card-menus {\n  display: flex;\n  gap: 10px;\n}\n\n/* Compose Message Button */\n.btn-compose {\n  background-color: #F79222;\n  border-color: #F79222;\n  color: white;\n  transition: all 0.2s ease;\n  font-weight: 600;\n}\n\n.btn-compose:hover {\n  background-color: #e07b10;\n  border-color: #e07b10;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
